import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mainContainer" }
const _hoisted_2 = { class: "detailsContainer" }
const _hoisted_3 = { class: "cashBackTotal" }
const _hoisted_4 = { class: "label-text" }
const _hoisted_5 = { class: "totalValue" }
const _hoisted_6 = { key: 0 }

import { PropType, ref, } from 'vue';
import CashBackHistoryCard from './cashBackHistoryCard.vue';
import { formatCurrency } from '@/utils/commonFunction';
import { getBetList, getDayList } from '@/view/components/supportFunction';


export default /*@__PURE__*/_defineComponent({
  __name: 'cashbackWeekDetails',
  props: {
    cashbackTotal: {
        type: Number,
        default: () => 0
    },
    betList: {
        type: Array as PropType<any[]>,
        default: () => []
    },
    istodayClaimed: {
        type: Boolean,
        default: () => false
    },
    type: {
        type: String,
        default: () => ''
    },
    title: String,
    todayDayRewards: {
        type: Object as PropType<any>
    },
    isShowTodayCard: {
        type: Boolean,
        default: () => false
    },
},
  setup(__props) {

const props = __props
const showDetails = ref(false)
const handleDetailsShow = () => {
    showDetails.value = !showDetails.value
}
const setdayList = (data: any) => getDayList(props.type, data)
const setBetList = () => getBetList(props.betList, props.isShowTodayCard)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('activity.cashBackTotal')), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(formatCurrency)(__props.cashbackTotal)), 1)
      ]),
      _createElementVNode("div", null, [
        (__props.isShowTodayCard)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(CashBackHistoryCard, {
                createTime: __props.todayDayRewards.date,
                "total-amount": __props.todayDayRewards.totalAmount,
                istodayClaimed: __props.istodayClaimed,
                title: __props.title,
                "day-list": __props.todayDayRewards.rewards
              }, null, 8, ["createTime", "total-amount", "istodayClaimed", "title", "day-list"])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(setBetList(), (item, index) => {
          return (_openBlock(), _createBlock(CashBackHistoryCard, {
            key: index,
            createTime: item.lossDate ?? item.createTime,
            title: __props.title,
            "day-count": item.dayCount ?? item.day,
            "activity-status": item.status,
            "total-amount": item.totalBetAmount ?? item.rechargeTotal ?? item.totalBetLoss,
            istodayClaimed: __props.istodayClaimed,
            "available-amount": item.remainGiftAmount ?? item.availableAmount,
            "day-list": setdayList(item.dayRewards)
          }, null, 8, ["createTime", "title", "day-count", "activity-status", "total-amount", "istodayClaimed", "available-amount", "day-list"]))
        }), 128))
      ])
    ])
  ]))
}
}

})